import { Observable } from 'rxjs'

export enum CaptureAuctionFieldEnum {
  Off = 'off',
  Optional = 'optional',
  Required = 'required',
}

export interface SharedAuctionFacade {
  auctionCountry$: Observable<string>
  capturePhoneNumbers$: Observable<CaptureAuctionFieldEnum>
  ticketsLabel$: Observable<string>
}
